import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/components/elements/toast/toast.service';
import { ConfirmationModalComponent } from 'src/app/shared/components/confirmation-modal/confirmation-modal.component';
import { AdsService } from 'src/app/shared/services/http-services/Ads/ads.service';

@Component({
  selector: 'app-view-ad',
  templateUrl: './view-ad.component.html',
  styleUrls: ['./view-ad.component.scss']
})
export class ViewAdComponent implements OnInit {

  @Input() ad: any;
  @Output() adUpdated: EventEmitter<any> = new EventEmitter<any>();
  isSaving: boolean = false;

  isImageError: boolean = false;

  linkForm!: UntypedFormGroup;

  constructor(private adService: AdsService, private formBuilder: UntypedFormBuilder, private router: Router, private modalService: NgbModal, private toastService: ToastService, private cdr: ChangeDetectorRef, private confirmationService: ConfirmationModalComponent) {
    this.linkForm = this.formBuilder.group({
      link: ['']
    });
  }

  ngOnInit(): void {
    console.log("ad", this.ad);
  }

  onImageError(event: Event): void {
    this.isImageError = true;
  }
  openModal(model: any, event: any) {
    event?.stopPropagation();
    this.modalService.open(model, {
      size: 'md',
      centered: true,
    });
  }

  async addLink() {
    if (this.linkForm.invalid) {
      this.toastService.showDangerMessage('Please enter a valid link');
      return;
    }
    const result = await this.confirmationService.confirmationAlert((this.ad.link == null ? 'Add' : 'Change') + ' Link', 'Are you sure you want to add this link ?');

    if (!result) {
      return;
    }

    this.isSaving = true;

    const model = {
      AdID: this.ad.id,
      Link: this.linkForm.value.link
    }

    console.log("model", model);

    this.adService.AddLinkToAd(model).subscribe({
      next: (res: any) => {
        this.isSaving = false;
        this.toastService.showSuccessMessage('Link added successfully');
        this.modalService.dismissAll();
        this.adUpdated.emit();
        this.router.navigate(['/ads']);
        this.cdr.detectChanges();
      },
      error: (err: any) => {
        this.isSaving = false;
        console.log(err);
        this.toastService.showDangerMessage('Failed to add link');
      }
    });
  }

  async toggleAdStatus() {
    const result = await this.confirmationService.confirmationAlert('Change Ad Status', 'Are you sure you want to change the status of this ad?');

    if (!result) {
      return;
    }

    this.isSaving = true;

    this.adService.ChangeAdStatus(this.ad.id).subscribe({
      next: (res: any) => {
        this.isSaving = false;
        this.toastService.showSuccessMessage('Ad status changed successfully');
        this.modalService.dismissAll();
        this.router.navigate(['/ads']);
        this.adUpdated.emit();
        this.cdr.detectChanges();
      },
      error: (err: any) => {
        this.isSaving = false;
        console.log(err);
        this.toastService.showDangerMessage('Failed to change ad status');
      }
    });
  }

  async deleteAd() {
    const result = await this.confirmationService.confirmationAlert(
      'Delete Ad',
      'Are you sure you want to delete this ad? This action cannot be undone.'
    );

    if (!result) {
      return;
    }

    this.isSaving = true;

    this.adService.DeleteAd(this.ad.id).subscribe({
      next: (res: any) => {
        this.isSaving = false;
        if (res.succeeded) {
          this.toastService.showSuccessMessage('Ad deleted successfully');
          this.modalService.dismissAll();
          this.adUpdated.emit();
          this.cdr.detectChanges();
        }
      },
      error: (err: any) => {
        this.isSaving = false;
        console.log(err);
        this.toastService.showError(err);
      }
    });
  }

  close(): void {
    this.modalService.dismissAll();
  }

}
